export const getOrder = '/orders';
export const getDeliveryEstimate = '/appSetting/delivery-estimate';
export const updateDeliveryEstimate = '/appSetting/delivery-estimate';
